import { APP_INFO, NAMESPACE } from '../constants';
import appInfo from './appInfo';
import login from './login';

export default {
  [APP_INFO]: appInfo,
  [NAMESPACE]: login,
};
